import { useFetch } from '../../use-fetch/use-fetch';
import { accountRequestConfig } from '../../../request-config/account/account.request-config';
import { useQuery } from 'react-query';
import { ReactQueryKeys } from '../../../common/enums';
import { AxiosResponse } from 'axios';
import { decodeBase64 } from '../../../utils/decode-encode-base64';

const modifyResponse = (response: AxiosResponse<string>) => {
  if (response.status === 200) {
    return decodeBase64(response.data);
  }
  return undefined;
};

const useMapSettings = () => {
  const { fetch } = useFetch<string>({
    isShowLoading: false,
    isShowErrorSnackbar: false,
    ...accountRequestConfig.getMapSettings()
  });

  const { data: settings } = useQuery<AxiosResponse<string>, unknown, string | undefined>(
    [ReactQueryKeys.GetMapSettings],
    fetch,
    {
      select: modifyResponse
    }
  );

  return settings;
};

export default useMapSettings;
